import { EntityName } from 'record-it-time-common/EntityName';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';
export function useUserGroupDeleteHandler(userGroup) {
  return useEntityDeleteHandler(EntityName.UserGroup, userGroup, _temp);
}
function _temp(ug) {
  return ug.name;
}